import {Outlet, useLocation} from 'react-router-dom';
import Step from './Step';
import {useMetaData} from '@/query/hooks';
import {WebSvg} from '@/assets';

const StepHeader = () => {
  const location = useLocation();
  const route = location.pathname.split('/').pop();
  const meta = useMetaData();
  const activeIndex = meta.steps.findIndex(step => step.route === route);

  if (activeIndex === -1) {
    return <Outlet />;
  }

  const activeRoute = meta.steps[activeIndex];
  return (
    <div>
      <section className="d-flex justify-content-between w-100 step-part-head step-part-dashboard">
        <div className="w-100 d-flex justify-content-between mb-1 mt-1">
          {meta.steps.map((step, index) => {
            const routeIndex = meta.steps.findIndex(
              step => step.route === route,
            );
            const active = index <= routeIndex;
            const isLast = index === meta.steps.length - 1;
            return (
              <div
                key={index}
                className={`d-flex pt-2 pb-2 step-part  ${active ? 'step-part-active' : ''}`}
                style={{flex: isLast && meta.steps.length > 2 ? undefined : 1}}
              >
                <Step
                  active={active}
                  isLast={isLast}
                  completed={index < routeIndex}
                  {...step}
                />
              </div>
            );
          })}
        </div>
      </section>
      <section className="d-flex justify-content-between w-100 step-part-head step-part-mobile">
        <div
          className="top-line"
          style={{
            width: `${(activeIndex + 1) * (100 / meta.steps.length)}%`,
          }}
        />
        <div className="w-100 d-flex justify-content-between mb-1  ">
          <div className="d-flex pt-2 pb-2 step-part w-100">
            <div className="d-flex align-items-start pt-1">
              <img src={WebSvg.ActiveStepIcon} />
            </div>
            <div className="steps d-flex w-100 flex-column px-1">
              <div className="head d-flex align-items-center w-100">
                <span className="text-nowrap">{activeRoute.title}</span>
                <WebSvg.StepLine />
              </div>
              <div className="stepHelp">
                <img src={WebSvg.StepHelp} /> Help
              </div>
            </div>
            <div className="d-flex text-nowrap step-sub-text">
              Step {activeIndex + 1} of {meta.steps.length}
            </div>
          </div>
        </div>
      </section>
      <Outlet />
    </div>
  );
};

export default StepHeader;
